export var phoneCard = function phoneCard(centralApi) {
  return {
    get: function get(id) {
      return centralApi.get("/phone-card/".concat(id));
    }
  };
};